import { render } from "./GeneralInfoList.vue?vue&type=template&id=0c0cecfc&scoped=true"
import script from "./GeneralInfoList.vue?vue&type=script&lang=js"
export * from "./GeneralInfoList.vue?vue&type=script&lang=js"

import "./GeneralInfoList.vue?vue&type=style&index=0&id=0c0cecfc&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0cecfc"]])

export default __exports__